import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePermissionHint } from "@/features/auth/context/permission-hint-context";
import { useAuth } from "@/features/auth/context/auth-context";
import { useLocation } from "react-router-dom";

export const PermissionHintFab: React.FC = () => {
  const { latestHint, isOpen, closeHint } = usePermissionHint();
  const { token, isValid, selectedCompanyId } = useAuth();
  const location = useLocation();
  const [expanded, setExpanded] = React.useState(false);

  const isAuthRoute =
    location.pathname === "/login" ||
    location.pathname === "/forgot-password" ||
    location.pathname === "/reset-password";
  const hasCompletedLogin = Boolean(token && isValid && selectedCompanyId);
  const hasActivePermissionIssue = Boolean(
    isOpen && latestHint && latestHint.missingPermissions.length > 0
  );

  React.useEffect(() => {
    if (isOpen) {
      setExpanded(true);
    }
  }, [isOpen]);

  if (isAuthRoute || !hasCompletedLogin) {
    return null;
  }

  if (!hasActivePermissionIssue) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col items-end gap-2">
      {expanded && isOpen && latestHint && (
        <div className="w-[320px] rounded-lg border bg-background p-3 shadow-lg">
          <div className="mb-2 flex items-start justify-between">
            <div>
              <p className="text-sm font-semibold">Permisos faltantes</p>
              <p className="text-xs text-muted-foreground">
                {latestHint.scope === "route" ? "Acceso a vista" : "Acción bloqueada"}:{" "}
                {latestHint.actionLabel}
              </p>
            </div>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6"
              onClick={() => {
                setExpanded(false);
                closeHint();
              }}
            >
              <X className="h-3 w-3" />
            </Button>
          </div>

          <div className="space-y-2">
            <div>
              <p className="text-xs font-medium">Requeridos</p>
              <p className="text-xs text-muted-foreground">
                {latestHint.requiredPermissions.join(", ")}
              </p>
            </div>
            <div>
              <p className="text-xs font-medium">Faltantes</p>
              <p className="text-xs text-destructive">
                {latestHint.missingPermissions.join(", ")}
              </p>
            </div>
          </div>
        </div>
      )}

      <Button
        className="h-12 w-12 rounded-full shadow-lg"
        onClick={() => setExpanded((prev) => !prev)}
        title="Ver permisos faltantes"
      >
        <AlertTriangle className="h-5 w-5" />
      </Button>
    </div>
  );
};
